import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/context/LanguageContext";

const FAQ = () => {
  const { t } = useLanguage();
  return (
    <section id="faq" className="relative py-20 md:py-28 bg-[#0c0c0c]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
            <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
            {t.faq.eyebrow}
          </div>
          <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tight">
            {t.faq.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              className="rounded-2xl border border-white/10 bg-[#111] px-5 md:px-6 data-[state=open]:border-[#e10600]/40 transition"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-start text-white hover:no-underline py-5 font-display font-bold text-base md:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed text-sm md:text-[15px] pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
